import React from 'react';
import { Label } from 'components/src/typography';
import { colors } from 'components/src/foundation';
import { TwitterIcon, FacebookIcon, LinkedInIcon } from 'components/src/svg';
import { FacebookShareButton, TwitterShareButton, LinkedinShareButton } from 'react-share';

type Props = {
  title: string;
};

const SocialMedia = ({ title = '' }: Props) => {
  const [currentUrl, setCurrentUrl] = React.useState('');

  React.useEffect(() => {
    setCurrentUrl(window.location.href);
  }, []);

  return (
    <>
      <Label classes="mb-16 text-black-75">{'Deila'}</Label>
      <div className="mx-auto grid grid-flow-col gap-24 lg:grid-flow-row lg:gap-16">
        <FacebookShareButton url={currentUrl} title={title}>
          <FacebookIcon color={colors.red[100]} />
        </FacebookShareButton>
        <TwitterShareButton url={currentUrl} title={title}>
          <TwitterIcon color={colors.red[100]} />
        </TwitterShareButton>
        <LinkedinShareButton url={currentUrl} title={title}>
          <LinkedInIcon color={colors.red[100]} />
        </LinkedinShareButton>
      </div>
    </>
  );
};
export default SocialMedia;
